export const slicesArray = ["debugLogs", "errorsLogs"];
export const listToBeReseted = ["debugLogs", "errorsLogs"];
